/**
 * The player is not initialized.
 */
export const NOT_INITIALIZED = 1;

/**
 * The player is not initialized.
 */
export const INITIALIZING = 2;

/**
 * The player is not initialized.
 */
export const INITIALIZED = 3;

/**
 * Requested to play a video while creating a player.
 */
export const PENDING_PLAY = 4;

/**
 * Ready to play a video.
 */
export const IDLE = 5;

/**
 * Loading a video.
 */
export const LOADING = 6;

/**
 * Play request has been sent to the player, but it is aborted later.
 */
export const PLAY_REQUEST_ABORTED = 7;

/**
 * Now playing a video
 */
export const PLAYING = 8;

/**
 * Any error has been occurred.
 */
export const ERROR = 9;
